import React from 'react'
import injectSheet from 'react-jss'
import { Helmet } from 'react-helmet'
import {
  NavLink,
  Switch,
  Redirect,
  Route,
} from 'react-router-dom'
import { purgeState } from '../../../utils/localStorage'
import {
  Admin,
  AdminConfiguration,
  AdminHouseType,
  AdminOfferList,
  AdminTopStepper,
  AdminUserList,
  ErrorContainer,
  Image,
  InitContainer,
  Login,
  Logout,
} from '../../'

const AdminLayout = (props) => {
  const {
    classes,
    initialize,
    location,
    history,
    steps,
    user,
  } = props

  const resetApp = () => {
    purgeState()
    window.location.reload()
    history.push('/admin')
  }

  const currentPath = location.pathname.split('/')[2]

  return (
    <ErrorContainer resetApp={resetApp}>
      <InitContainer initialize={initialize}>
        <div className={classes.app}>
          <Helmet>
            <meta charSet="utf-8" />
            <title>hausconfigurator</title>
          </Helmet>
          <header className={`${classes.section} ${classes.topSection}`}>
            <div className={`${classes.gridContainer}`}>
              <div className={`${classes.topContainer}`}>
                <NavLink
                  className={`${classes.title}`}
                  exact
                  to="/admin"
                >
                  <Image
                    src="images/static/logo.svg"
                    alt="Hauskonfigurator"
                  />
                </NavLink>
                <Logout />
              </div>
              <AdminTopStepper
                classNames={`${classes.adminStepper} ${!user && 'invisible'}`}
                currentPath={currentPath}
                history={history}
                steps={steps}
              />
            </div>
          </header>
          <section className={`${classes.section} ${classes.mainSection}`}>
            <Switch location={location} >
              <Route
                exact
                path="/admin"
                render={() => (
                  (user ? (
                    <Admin
                      history={history}
                      steps={steps}
                    />
                  ) : (
                    <Redirect to="/admin/login" />
                  )
                ))}
              />
              <Route
                exact
                path="/admin/angebote"
                render={() => (
                  (user ? (
                    <AdminOfferList />
                  ) : (
                    <Redirect to="/admin/login" />
                  )
                ))}
              />
              <Route
                exact
                path="/admin/haustypen"
                render={() => (
                  (user ? (
                    <AdminHouseType />
                  ) : (
                    <Redirect to="/admin/login" />
                  )
                ))}
              />
              <Route
                exact
                path="/admin/konfigurationen"
                render={() => (
                  (user ? (
                    <AdminConfiguration />
                  ) : (
                    <Redirect to="/admin/login" />
                  )
                ))}
              />
              <Route
                exact
                path="/admin/benutzer"
                render={() => (
                  (user && user.role === 'Admin' ? (
                    <AdminUserList />
                  ) : (
                    <Redirect to="/admin" />
                  )
                ))}
              />
              <Route
                path="/admin/login"
                component={Login}
              />
            </Switch>
          </section>
        </div>
      </InitContainer>
    </ErrorContainer>
  )
}

const styles = theme => ({
  '@global': {
    body: {
      margin: 0,
      padding: 0,
      fontFamily: 'Helvetica, sans-serif',
    },
    '*': {
      boxSizing: 'border-box',
      outline: 'none',
    },
  },
  app: {
    backgroundColor: theme.colors.main_2,
  },
  section: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    width: '100vw',
  },
  topSection: {
    backgroundColor: theme.colors.main_2,
    position: 'fixed',
    top: 0,
    left: 0,
    padding: `0 0 ${theme.sizes.gutter / 2}px 0`,
    boxShadow: theme.shadow.initial,
    zIndex: 100,
  },
  adminStepper: {
    width: '100%',
    opacity: 1,
    visibility: 'visible',
    transition: [
      {
        property: 'opacity',
        duration: theme.speed.fast,
      },
    ],
    '&.invisible': {
      opacity: 0,
      visibility: 'hidden',
    },
  },
  mainSection: {
    backgroundColor: theme.colors.secondary_3a,
  },
  gridContainer: {
    position: 'relative',
    width: '100vw',
    maxWidth: `${theme.sizes.container}px`,
  },
  topContainer: {
    display: 'flex',
  },
  title: {
    width: '100%',
    display: 'block',
    textDecoration: 'none',
    color: theme.colors.main_3,
    padding: `0 ${theme.sizes.gutter / 2}px`,
    '& > div': {
      width: '100%',
      maxWidth: '250px',
      padding: `${theme.sizes.gutter / 2}px 0`,
    },
  },
})

export default injectSheet(styles)(AdminLayout)



// WEBPACK FOOTER //
// ./src/modules/admin/components/adminLayout.jsx